import React from 'react';
import { Box, Button } from '@material-ui/core';

const ActionButtons = ({
  handleSave,
  isSaving,
  isLoading,
  changedRowsCount
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        disabled={isSaving || isLoading || changedRowsCount === 0}
      >
        {isSaving ? 'שומר...' : 'שמור'}
      </Button>
    </Box>
  );
};

export default ActionButtons;
